import { render } from "./WikiBreadCrumbs.vue?vue&type=template&id=372316ce&scoped=true&ts=true"
import script from "./WikiBreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./WikiBreadCrumbs.vue?vue&type=script&lang=ts"

import "./WikiBreadCrumbs.vue?vue&type=style&index=0&id=372316ce&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372316ce"]])

export default __exports__